import algoliasearch from 'algoliasearch/lite';

export const getAlgoliaSearchClient = () => {
    const algoliaInstance = algoliasearch(window.algolia.app_id, window.algolia.api_key);

    return {
        search(requests) {
            const newRequests = requests.map(request => {
                if (window.internalIPs.includes(window.userIP)) {
                    request.params.analytics = false;
                    request.params.clickAnalytics = false;
                }

                // test for empty string and change request parameter: analytics
                if (
                    !request.indexName.includes('furniture') &&
                    (!request.params.query || request.params.query.length === 0)
                ) {
                    request.params.analytics = false;
                    request.params.clickAnalytics = false;
                }

                // Remove duplicate filters
                if (request.params.facetFilters) {
                    request.params.facetFilters.forEach((facetFilter, facetFilterIndex) => {
                        const sortedFilters = facetFilter.slice().sort();
                        const normalizedFilters = [];

                        sortedFilters.forEach((sortedFilter, sortedFilterIndex) => {
                            const nextValue = sortedFilters[sortedFilterIndex + 1] || '';

                            if (sortedFilter.toUpperCase() !== nextValue.toUpperCase()) {
                                normalizedFilters.push(sortedFilter);
                            }
                        });

                        request.params.facetFilters[facetFilterIndex] = normalizedFilters;
                    });
                }

                return request;
            });

            return algoliaInstance.search(newRequests);
        },
    };
};

export const normalizeFilterItems = items => {
    const refinedItemsWithNoCount = items.filter(item => item.isRefined && item.count === 0);
    refinedItemsWithNoCount.forEach(refinedItemWithNoCount => {
        const foundEquivalentIndex = items.findIndex(
            item =>
                item.label !== refinedItemWithNoCount.label &&
                item.label.toUpperCase() === refinedItemWithNoCount.label.toUpperCase()
        );

        items[foundEquivalentIndex].isRefined = true;
        items[foundEquivalentIndex].value = refinedItemWithNoCount.value;
    });

    return items.filter(item => !refinedItemsWithNoCount.map(refinedItem => refinedItem.label).includes(item.label));
};

export const normalizeRefinements = refinements => {
    const updatedRefinements = { ...refinements };

    Object.keys(refinements).forEach(refinementKey => {
        let refinementList = refinements[refinementKey];

        if (!Array.isArray(refinementList)) {
            return;
        }

        // Remove duplicates from refinement list values
        const normalizedRefinementList = [];

        refinementList = refinementList.slice().sort((a, b) => {
            const lowerA = a.toLowerCase();
            const lowerB = b.toLowerCase();

            if (lowerA === lowerB) {
                return 0;
            }

            return lowerA < lowerB ? -1 : 1;
        });

        refinementList.forEach((refinementListItem, refinementListItemIndex) => {
            const nextItem = refinementList[refinementListItemIndex + 1] || '';

            if (refinementListItem.toString().toUpperCase() !== nextItem.toString().toUpperCase()) {
                normalizedRefinementList.push(refinementListItem);
            }
        });

        updatedRefinements[refinementKey] = normalizedRefinementList;
    });

    return updatedRefinements;
};
